// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2337b4cf","457":"615490c5","484":"2049783d","551":"481d0451","851":"8293355d"}[chunkId] + ".chunk.js";
};